import { useEffect, useMemo } from 'react';

import { INITIAL_INSURANCE_FORM_STATE } from '../../constants/insurance/initial-insurance-form-state';

import { useFormState } from '../../hocs/useFormWithValidation';
import useValidatePatientInsuranceForm from './useValidatePatientInsuranceForm';
import useInsuranceRelationOptions from '../selectOptions/useInsuranceRelationOptions';

import {
  getInitialInsuranceFormValues,
  validateInsuranceFormFields,
} from '../../utils/manage-insurances/get-initial-insurance-form-values';

export function useInsuranceForm(patientInsurance, flowType) {
  const { formState, handleFormChange } = useFormState(
    INITIAL_INSURANCE_FORM_STATE,
  );

  const { hideInsuranceRelationFieldOrInfo } = useInsuranceRelationOptions();

  const {
    formErrors,
    setFormErrors,
    validateFormFields,
  } = useValidatePatientInsuranceForm();

  const isValid =
    validateInsuranceFormFields({
      formState,
      hideInsuranceRelationFieldOrInfo,
    }) && !Object.values(formErrors).filter(Boolean).length;

  const clearForm = () => {
    handleFormChange(INITIAL_INSURANCE_FORM_STATE);
  };

  useEffect(() => {
    if (patientInsurance) {
      const values = getInitialInsuranceFormValues({
        insurance: patientInsurance,
        isAdditionalInsurance: false,
        flowType,
      });

      handleFormChange(values);
    } else {
      handleFormChange(INITIAL_INSURANCE_FORM_STATE);
    }
  }, []);

  return useMemo(
    () => ({
      clearForm,
      formErrors,
      formState,
      handleFormChange,
      isValid,
      setFormErrors,
      validateFormFields,
    }),
    [
      clearForm,
      formErrors,
      formState,
      handleFormChange,
      isValid,
      setFormErrors,
      validateFormFields,
    ],
  );
}



// WEBPACK FOOTER //
// ./src/hooks/patientInsurance/useInsuranceForm.js